// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__T56ap","textContent":"styles_textContent__NcAQd","headerSectionLink":"styles_headerSectionLink__AW6C9"};